// This is WatchlistTable.js
// import React, { useState, useRef, useEffect } from 'react';
//  import React, { useState, useRef, useContext } from 'react';
 import React, { useState, useRef, useContext, useEffect } from 'react';
 import { useNavigate } from 'react-router-dom';

import InfoTooltip from './InfoTooltip';
// import MetricsFilter from './MetricsFilter';
import definitions from '../constants/metricsDefinitions';
import './WatchlistTable.css';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
import { StockComparisonContext } from '../contexts/StockComparisonContext';
import { METRIC_FIELDS } from '../constants/metricFields';


// All available metrics
// All available metrics for the watchlist metric picker
// Derived from shared METRIC_FIELDS to keep everything in sync
const ALL_METRICS = METRIC_FIELDS.map(m => ({
  label: m.label,
  key: m.value
}));


const WatchlistTable = ({ 
  watchlistStocks, 
  metricsData, 
  selectedMetrics, 
  setSelectedMetrics, 
  removeFromWatchlist,
  loading
}) => {
  // State for dropdown visibility
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // State for dropdown visibility
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // Ref for filter container to detect outside clicks
  const filterRef = useRef(null);


    // Get selection state and functions from context
  const { selectedForComparison, toggleSelection, clearSelection } = useContext(WatchlistContext);
  const { setStocksFromWatchlist } = useContext(StockComparisonContext);
  const navigate = useNavigate();

  // Handle comparison of selected stocks
  const handleCompare = () => {
    if (selectedForComparison.length === 0) return;
    
    // Set the stocks in the comparison context
    setStocksFromWatchlist(selectedForComparison);
    
    // Clear selection from local storage
    clearSelection();
    
    // Navigate to comparison page
    navigate('/comparison');
  };



  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDropdownOpen && filterRef.current && !filterRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  // Toggle metric selection
  const toggleMetric = (metric) => {
    const isSelected = selectedMetrics.some(m => m.key === metric.key);
    
    if (isSelected) {
      setSelectedMetrics(prev => prev.filter(m => m.key !== metric.key));
    } else {
      setSelectedMetrics(prev => [...prev, metric]);
    }
  };



  return (
    <div className="table-container">

      <div className="watchlist-actions">
        <button 
          className="compare-btn"
          disabled={selectedForComparison.length === 0}
          onClick={handleCompare}
        >
          Compare Selected ({selectedForComparison.length})
        </button>
      </div>


      <div className="metrics-filter-container" ref={filterRef}>
        <button 
          className="metrics-filter-button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          Add/Remove Metrics
        </button>
        
        {isDropdownOpen && (
          <div className="metrics-dropdown">
            {ALL_METRICS.map(metric => (
              <div key={metric.key} className="metric-option">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedMetrics.some(m => m.key === metric.key)}
                    onChange={() => toggleMetric(metric)}
                  />
                  {metric.label}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="table-scroll">
        <table className="watchlist-table">
          <thead>
            <tr>
            <th className="select-column">Select</th>

              <th className="stock-column">Stock</th>
              {selectedMetrics.map(metric => (
                <th key={metric.key} className="metric-column">
                  <div className="metric-header">
                    {metric.label}
                    <InfoTooltip text={definitions[metric.key] || "No description"} />
                  </div>
                </th>
              ))}
              <th className="action-column">Actions</th>
            </tr>
          </thead>
          <tbody>
            {watchlistStocks.map(stock => (
              <tr key={stock}>

                <td className="select-cell">
                  <input
                    type="checkbox"
                    checked={selectedForComparison.includes(stock)}
                    onChange={() => toggleSelection(stock)}
                  />
                </td>

                <td className="stock-cell">{stock}</td>
                {selectedMetrics.map(metric => (
                  <td key={`${stock}-${metric.key}`} className="metric-cell">
                    {loading && !metricsData[stock] ? (
                      <span className="loading-placeholder">Loading...</span>
                    ) : metricsData[stock] && metricsData[stock][metric.key] != null ? (
                      metricsData[stock][metric.key].toFixed(2)
                    ) : (
                      "NA"
                    )}
                  </td>
                ))}
                <td className="action-cell">
                  <button 
                    className="remove-button"
                    onClick={() => removeFromWatchlist(stock)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WatchlistTable;